<mat-form-field
  appearance="outline"
  floatLabel="always"
  subscriptSizing="dynamic"
  class="phone-input-field"
>
  <mat-label>{{ label }}</mat-label>

  <button
    matPrefix
    type="button"
    class="country-trigger-btn"
    [matMenuTriggerFor]="countryMenu"
    (menuOpened)="onMenuOpened()"
    (click)="$event.stopPropagation()"
    [disabled]="isDisabled"
    aria-label="Select country code"
  >
    +{{ selectedCountry?.dialCode }}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <input
    matInput
    class="phone-number-input"
    type="tel"
    [value]="displayValue"
    [disabled]="isDisabled"
    [required]="required"
    (input)="onPhoneInput($event)"
    (blur)="onTouched()"
    autocomplete="tel"
    [attr.aria-label]="label"
  />

  <mat-icon matSuffix class="phone-suffix-icon">phone</mat-icon>
</mat-form-field>

<mat-menu #countryMenu="matMenu" class="country-menu-panel">
  <div class="country-search-wrapper" (click)="$event.stopPropagation()">
    <mat-icon class="search-icon">search</mat-icon>
    <input
      #countrySearchInput
      class="country-search-input"
      type="text"
      [formControl]="searchCtrl"
      placeholder="Search countries..."
      autocomplete="off"
      (keydown)="$event.stopPropagation()"
    />
  </div>
  @for (country of filteredCountries; track country.isoCode) {
    <button
      mat-menu-item
      class="country-option"
      (click)="onCountrySelected(country)"
    >
      <span class="country-name">{{ country.name }}</span>
      @if (country.nativeName && country.nativeName !== country.name) {
        <span class="country-native"> ({{ country.nativeName }})</span>
      }
      <span class="country-dial-code"> +{{ country.dialCode }}</span>
    </button>
  }
</mat-menu>
